import {
  Box,
  Flex,
  Link,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby';

const DesktopNavCategorySubmenu = () => {

  return (
    <Box bg={mode('white', 'gray.800')} px="8" pt="8" pb="10">
      <Flex justify="space-between" width="full" fontSize="sm" maxW="8xl" mx="auto">
        <Flex width="480px" justify="space-between">
          <Box width="full">
            <Text fontWeight="semibold" mb="6">
              {/* {data.category.label} */}
            </Text>
            <Stack spacing="4" align="flex-start">
             
            </Stack>
          </Box>
          <Box width="full">
            <Text fontWeight="semibold" mb="6">
              {/* {data.featured.label} */}
            </Text>
            <Stack spacing="4" align="flex-start">
              {/* {data.featured.links.map((link, i) => (
                <Link key={i}>{link.label}</Link>
              ))} */}
            </Stack>
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}

const MobileNavCategorySubmenu = () => {

  const query = useStaticQuery(graphql`
    {
      allWpProductCategory {
        nodes {
          name
          slug
          count
        }   
      }
    }
  `)
 
  const data = query.allWpProductCategory.nodes
    
    return (
    <Box p="5" backgroundColor='white' width="100%" height="100%" overflowY="auto">
      <Stack spacing="10">
        <Box>
          <Text fontWeight="bold" mb="4">
            {/* {data.category.label} */}
          </Text>
          <SimpleGrid columns={{base: 1, sm: 2}} spacing="4">
            {data.map((item: any) => {
              if (item.count !== null) {
                return <Link href={`/category/${item.slug}`} key={item.databaseId}> {item.name}</Link>
                  } else {
                    return <></>
                  }
            })}
          </SimpleGrid>
        </Box>
      </Stack>
    </Box>
  )
}

export const NavCategorySubmenu = {
  Mobile: MobileNavCategorySubmenu,
  Desktop: DesktopNavCategorySubmenu,
}